module.exports = __webpack_public_path__ + "img/battery-low.85bb46d0.svg";